import axios from "axios";
import {
  AddPlayerParam,
  DeleteCoachParam,
  GetCoachListParam,
} from "Interfaces/AppInterface";
import { ACADEMY_BASE_URL, BASE_URL, CONSTANT_URL } from "App/constants";
import { USER_ATTRIBUTES } from "Pages/Players/constants";
import { getAcademyId } from "Utils/utils";

export const getIndividualUserAcademyId = async (): Promise<number | null> => {
  try {
    const { data } = await axios.get(
      `${CONSTANT_URL}?key=individual_user_academy_id`
    );
    return data?.individual_user_academy_id || null;
  } catch (error) {
    console.error("Failed to fetch individual_user_academy_id:", error);
    return null;
  }
};

export const deleteCoach = async ({ academyId, id }: DeleteCoachParam) => {
  const { data } = await axios.put(
    `${ACADEMY_BASE_URL}${getAcademyId(academyId)}/coaches/${id}/deactivate`,
    {
      coach: {
        is_active: "false",
      },
    }
  );

  return data;
};

export const getCoachList = async ({
  academyId,
  searchInput,
  selectValue,
  currentPage,
}: GetCoachListParam) => {
  const resolvedAcademyId = getAcademyId(academyId);
  const userAcademyId = getAcademyId(); // Check logged-in user's academy_id from localStorage
  const sportParamKey = userAcademyId ? "sport_id" : "master_sport_id";
  const queryParams = `page=${currentPage}&${sportParamKey}=${selectValue}&search=${searchInput}&order_by=name&order_type=asc`;
  const baseUrl = resolvedAcademyId
    ? `${ACADEMY_BASE_URL}${resolvedAcademyId}/coaches`
    : `${BASE_URL}coaches`;

  const { data } = await axios.get(`${baseUrl}?${queryParams}`);
  if (data) {
    return data;
  }
  return [];
};

export const addCoach = async ({
  academyId,
  param,
  isEditUser,
}: AddPlayerParam) => {
  const user_attributes: any = {};
  USER_ATTRIBUTES.forEach((ele: any) => {
    user_attributes[ele] = param[ele];
    delete param[ele];
  });
  delete param.image;
  if (isEditUser) {
    param.coach_sports &&
      param.coach_sports.length &&
      param.coach_sports.forEach((sportData: any) => {
        delete sportData.sport;
      });
    await axios.put(
      `${ACADEMY_BASE_URL}${getAcademyId(academyId)}/coaches/${param.id}`,
      {
        coach: {
          ...param,
          user_attributes,
        },
      }
    );
    return;
  }

  const userAcademyId = getAcademyId();
  let createAcademyId = getAcademyId(academyId);

  if (!userAcademyId) {
    const individualAcademyId = await getIndividualUserAcademyId();
    createAcademyId = individualAcademyId;
  }

  await axios.post(`${ACADEMY_BASE_URL}${createAcademyId}/coaches`, {
    coach: {
      ...param,
      user_attributes,
    },
  });

  return [];
};

export const getAllCoach = async (sportId: string, searchInput: string) => {
  const resolvedAcademyId = getAcademyId();
  const userAcademyId = getAcademyId(); // Check logged-in user's academy_id from localStorage
  const sportParamKey = userAcademyId ? "sport_id" : "master_sport_id";
  const baseUrl = resolvedAcademyId
    ? `${ACADEMY_BASE_URL}${resolvedAcademyId}/coaches`
    : `${BASE_URL}coaches`;

  const data = await axios.get(
    `${baseUrl}?${sportParamKey}=${sportId}&search=${searchInput}`
  );
  if (data) {
    return data.data.coaches;
  }
  return [];
};

export const getCoachVerificationRequests = async (
  page: number,
  search: string,
  sportId?: string,
  status?: "pending" | "rejected" | "approved"
) => {
  const sportQuery = sportId ? `&sport_id=${sportId}` : "";
  const statusQuery = status ? `&verification_request_status=${status}` : "";
  const { data } = await axios.get(
    `${BASE_URL}coaches/verification_requests?page=${page}&search=${search}${sportQuery}${statusQuery}`
  );
  return data;
};

export const getCoachVerificationRequest = async (id: number) => {
  const { data } = await axios.get(
    `${BASE_URL}coaches/${id}/verification_request`
  );
  return data;
};

export const updateCoachVerificationRequests = async (
  coachIds: number[],
  status: "approved" | "rejected"
) => {
  const { data } = await axios.patch(
    `${BASE_URL}coaches/verification_requests`,
    {
      coach_ids: coachIds,
      verification_request_status: status,
    }
  );
  return data;
};

export const markPaidReviewEligibility = async (
  coachId: number,
  listedAsAssetReviewer: boolean
) => {
  const { data } = await axios.patch(
    `${BASE_URL}coaches/${coachId}/mark_paid_review_eligibility`,
    {
      listed_as_asset_reviewer: listedAsAssetReviewer,
    }
  );
  return data;
};
